import VideoPlayerModal from "../../components/ui/VideoPlayerModal";
import BookButton from "../bookDemo/BookButton";
import FlipBookNav from "./components/FlipBookNav";
import FlipBook from "./components/FlipBook";
import StoryHeader from "./components/StoryHeader";
import StoryVideoHint from "./components/StoryVideoHint";
import useFlipBook from "./hooks/useFlipBook";
import useStoryVideo from "./hooks/useStoryVideo";

export default function StoryMobile() {
  const { showVideo, setShowVideo, videoUrl } = useStoryVideo();
  const { page, isFlipping, prevImg, nextImg, rotateY } = useFlipBook();

  return (
    <div className="flex h-screen w-screen justify-center bg-pink1">
      <div className="relative flex min-h-screen w-screen min-w-[320px] max-w-[390px] flex-col bg-pink1">
        <StoryHeader />

        {/* 543 = pt:88 + height:420 + pb:35 */}
        <div className="hide-scrollbar pointer-events-none absolute left-0 top-0 h-[543px] w-screen overflow-auto pl-4 pt-[88px]">
          <FlipBook rotateY={rotateY} />
        </div>

        {/* 524 = pt:88 + height:420 + pb:16 */}
        <FlipBookNav
          page={page}
          isFlipping={isFlipping}
          onPrev={prevImg}
          onNext={nextImg}
          className="absolute right-7 top-[524px]"
        />

        <div className="relative mt-[455px] px-4">
          <StoryVideoHint variant="mobile" onPlay={() => setShowVideo(true)} />
        </div>

        {showVideo ? (
          <VideoPlayerModal
            videoTitle="Straight Play 4"
            videoUrl={videoUrl}
            setShowVideo={setShowVideo}
          />
        ) : null}

        <BookButton sourcePage="Story" />
      </div>
    </div>
  );
}
